import { memo } from 'react';
import {
  Accordion,
  RadioGroup,
  Separator,
  Stack,
  Text,
} from '@chakra-ui/react';

import { AccordionRadioGroupsSelecterProps } from './types/AccordionRadioGroupsSelecterProps';
import { AccordionRadioGroupsSelecterItemTitle } from './AccordionRadioGroupsSelecterItemTitle';

// FormLabel renders this field's label with the id `${name}-label`, and the
// radio group renders no label of its own, so it is named by that id.
const AccordionRadioGroupsSelecterComponent = ({
  _ref,
  groups,
  invalid,
  name,
  onBlur,
  onChange,
  value,
}: AccordionRadioGroupsSelecterProps) => (
  <RadioGroup.Root
    ref={_ref}
    aria-labelledby={`${name}-label`}
    bg="white"
    borderColor="border.brandedDefault"
    borderRadius="sm"
    borderStyle="solid"
    borderWidth={1}
    color="text.fg"
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    overflow="hidden"
    shadow="xl"
    size="lg"
    value={value !== undefined ? `${value}` : undefined}
  >
    <Accordion.Root asChild multiple>
      <Stack
        separator={
          <Separator borderColor="border.brandedDefault" my="0 !important" />
        }
        w="full"
      >
        {groups.map(({ icon, label, options }) => (
          <Accordion.Item key={label} borderBottomWidth={0} value={label}>
            <AccordionRadioGroupsSelecterItemTitle icon={icon}>
              {label}
            </AccordionRadioGroupsSelecterItemTitle>
            <Accordion.ItemContent borderRadius={0}>
              <Accordion.ItemBody pb={0} pt={0} px={0}>
                <Stack
                  bg="brandSecondary.subtle"
                  borderColor="border.brandedDefault"
                  borderTopWidth="1px"
                  gap={0}
                  separator={<Separator borderColor="border.brandedDefault" />}
                  w="full"
                >
                  {options.map((option) => (
                    <RadioGroup.Item
                      key={option.value}
                      colorPalette="brandPrimary"
                      invalid={invalid}
                      p={4}
                      value={`${option.value}`}
                    >
                      <RadioGroup.ItemHiddenInput />
                      <RadioGroup.ItemIndicator />
                      <RadioGroup.ItemText>
                        <Text>{option.label}</Text>
                      </RadioGroup.ItemText>
                    </RadioGroup.Item>
                  ))}
                </Stack>
              </Accordion.ItemBody>
            </Accordion.ItemContent>
          </Accordion.Item>
        ))}
      </Stack>
    </Accordion.Root>
  </RadioGroup.Root>
);

export const AccordionRadioGroupsSelecter = memo(
  AccordionRadioGroupsSelecterComponent,
);
